import { render, staticRenderFns } from "./SubCategoryInput.vue?vue&type=template&id=8385ba9e&"
import script from "./SubCategoryInput.vue?vue&type=script&lang=js&"
export * from "./SubCategoryInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports